module.exports = __webpack_public_path__ + "static/media/panel_yellow.00315f4d.svg";